/** This regex matches markdown link format. E.g. [Link Label](http://URL) */
export const MARKDOWN_LINK_REGEXP = /\[([^\]]+)\]\((https?:\/\/[^\s)]+)\)/g;

/** This regex matches a file name with an extension. e.g. "document 1.pdf" */
export const FILENAME_REGEXP = /\b[\w\-.,()(__)# ]+\.(pdf|doc|docx|tiff)\b/g;

export const THINKING_EVENTS_FADE_TIME = 1000;
// @i18n-ignore BE value comparation
export const THINKING_EVENTS_GENERATING_RESPONSE = 'Generating response...';
export const THINKING_EVENTS_ALL_DONE = 'ALL_DONE';
export const THINKING_EVENTS_SOURCE = 'RAG DATA FROM:';

/** Timeout in milliseconds for SSE stream inactivity (90 seconds) */
export const SSE_STREAM_TIMEOUT = 90000;

export const CITATIONS_FAILURE_KEY = 'citation_generation_failed';
export const SOME_HIGHLIGHTS_FAILED_KEY = 'some_highlights_failed';
export const HIGHLIGHT_GENERATION_FAILED_KEY = 'highlight_generation_failed';
